<template>
    <div class="main-container">
        <el-form :inline="true" :model="searchForm" size="small" ref="searchForm" @keyup.enter.native="handleSearch"
            label-width="70px">
            <el-form-item label="酒店名称" prop="hotelId">
                <el-select v-model="searchForm.hotelId" placeholder="请选择酒店名称" filterable style="width: 250px" remote :remote-method="remoteMethod" :loading="loading" @change="handleSelectHotel">
                    <el-option v-for="item in hotelList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
            </el-form-item>
            <div></div>
            <el-form-item label="楼层" prop="floor">
                <el-select v-model="searchForm.floor" placeholder="请选择楼层" clearable style="width: 120px">
                    <el-option v-for="item in floorList" :key="item.id" :label="item.floorName" :value="item.floorName"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="房间号" prop="roomNo">
                <el-input v-model="searchForm.roomNo" placeholder="请输入房间号" style="width: 170px"></el-input>
            </el-form-item>
             <el-form-item label="状态" prop="status">
                <el-select v-model="searchForm.status" placeholder="请选择状态" clearable style="width: 120px">
                    <el-option label="已入住" :value="1"></el-option>
                    <el-option label="未入住" :value="0"></el-option>
                    <!-- <el-option label="禁用" :value="3"></el-option> -->
                </el-select>
            </el-form-item>
            <el-form-item label="入住人" prop="name">
                <el-input v-model="searchForm.name" placeholder="请输入入住人" style="width: 170px"></el-input>
            </el-form-item>
            <el-form-item label="房间类型" prop="roomTypeId">
                <el-select v-model="searchForm.roomTypeId" placeholder="请选择房间类型" clearable style="width: 120px">
                    <el-option v-for="item in roomTypeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
            </el-form-item>
            
            <el-form-item>
                <el-button type="primary" @click="handleSearch" size="small">查询</el-button>
                <el-button @click="handleReset" size="small">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="room_list">
            <el-row :gutter="15">
                <el-col :span="5" v-for="(item,key) in tableData" :key="key">
                    <div class="room_item">
                        <span class="room_status status0" v-if="item.status == 0">未入住</span>
                        <span class="room_status" v-if="item.status == 1">{{ item.statusDesc }}</span>
                        <span class="room_status status3" v-if="item.status == 3">{{ item.statusDesc }}</span>
                        <div class="room_code">{{ item.floor }}-{{ item.roomNo }}</div>
                        <div class="room_type">{{ item.roomTypeName }}</div>
                        <div class="customer_info" v-if="item.status == 1">
                            <span>{{ item.name }}</span>
                            <div>{{ item.checkInArea }}</div>
                        </div>

                        <div class="customer_info" v-else>
                            <span>暂无住客信息</span>
                        </div>
                        <div class="room_action">
                            <el-button type="primary" size="mini" v-if="item.status == 0" @click="handleEdit(item)">编辑</el-button>
                            <el-button type="primary" size="mini" v-if="item.status == 1" @click="handleShowDetail(item)">详情</el-button>
                            <el-button style="background: #449B00;border-color: #449B00;" type="success" size="mini" @click="handleCheckInRoom(item)" v-if="item.status == 0">入住</el-button>
                            <!-- <el-button style="background: #449B00;border-color: #449B00;" type="success" size="mini" @click="handleExtendRoom(item)" v-if="item.status == 1">续住</el-button> -->
                            <el-button style="background: #9B3800;border-color: #9B3800;" type="warning" size="mini" @click="handleRefund(item)" v-if="item.status == 1">退房</el-button>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>

        <!-- 编辑 -->
        <EditRoomComponent :isRoom="isRoom" @close="isRoom = false" @confirm="handleConfirmRoom" :hotelId="searchForm.hotelId" :roomId="roomId"/>
        
        <!-- 入住 -->
        <CheckInRoomComponent :isCheck="isCheck" @close="isCheck = false" @confirm="handleConfirmRoom" :hotelId="searchForm.hotelId" :roomId="roomId"/>

        <!-- 续住 -->
        <ExtendRoomComponent :isExtend="isExtend" @close="isExtend = false" @confirm="handleConfirmRoom" :hotelId="searchForm.hotelId" :roomId="roomId"/>
        

        <!-- 查看详情 -->
        <el-dialog :visible.sync="isDetail" title="查看详情" width="850px" append-to-body destroy-on-close :close-on-press-escape="false" :close-on-click-modal="false">
            <el-form ref="modelForm" :model="modelForm" inline label-width="110px"
                style="margin: 0 20px" size="small" disabled>
                <el-form-item label="订单号" prop="orderNo">
                    <el-input type="text" v-model="modelForm.orderNo" style="width: 250px"></el-input>
                </el-form-item>
                <el-form-item label="预定时间" prop="createTime">
                    <el-input type="text" v-model="modelForm.createTime" style="width: 250px"></el-input>
                </el-form-item>
                <el-form-item label="房型" prop="roomTypeName">
                    <el-input type="text" v-model="modelForm.roomTypeName" style="width: 250px"></el-input>
                </el-form-item>
                <!-- <el-form-item label="房间数" prop="roomQty">
                    <el-input type="text" v-model="modelForm.roomQty" style="width: 250px"></el-input>
                </el-form-item> -->
                <el-form-item label="房价" prop="orderLastPay">
                    <el-input type="text" v-model="modelForm.orderLastPay" style="width: 250px"></el-input>
                </el-form-item>
                <el-form-item label="预定天数" prop="days">
                    <el-input type="text" v-model="modelForm.days" style="width: 250px"></el-input>
                </el-form-item>
                <el-form-item label="姓名" prop="customerName">
                    <el-input type="text" v-model="modelForm.customerName" style="width: 250px"></el-input>
                </el-form-item>
                <el-form-item label="电话号码" prop="customerMobile">
                    <el-input type="text" v-model="modelForm.customerMobile" style="width: 250px"></el-input>
                </el-form-item>
                <el-form-item label="身份证号码" prop="idNumber">
                    <el-input type="text" v-model="modelForm.idNumber" style="width: 250px"></el-input>
                </el-form-item>
                <el-form-item label="退房时间" prop="estimatedCheckOut">
                    <el-input type="text" v-model="modelForm.estimatedCheckOut" style="width: 250px"></el-input>
                </el-form-item>
                <el-form-item label="状态" prop="statusDesc">
                    <el-input type="text" v-model="modelForm.statusDesc" style="width: 250px"></el-input>
                </el-form-item>
                <!-- <el-form-item label="酒店备注" prop="hotelRemarks">
                    <el-input type="textarea" v-model="modelForm.hotelRemarks" style="width: 250px"></el-input>
                </el-form-item> -->
            </el-form>
            <div class="footer" style="margin: 0 20px; text-align: right">
                <el-button type="primary" size="small" @click="isDetail = false">关闭</el-button>
            </div>
        </el-dialog>

    
    </div>
</template>

<script>
import EditRoomComponent from "./editRoomComponent/index.vue";
import ExtendRoomComponent from "./extendRoomComponent/index.vue";
import CheckInRoomComponent from "./checkInRoomComponent/index.vue";
export default {
    components: {
        EditRoomComponent,
        ExtendRoomComponent,
        CheckInRoomComponent
    },
    data() {
        return {
            loading: false,
            searchForm: {
                hotelId: "",
                name: "",
                roomNo: "",
                roomTypeId: "",
                status: "",
            },
            isLoading: false,
            tableData: [],
            total: 0,
            roomTypeList: [],
            hotelList: [],

            isDetail: false,
            modelForm: {},

            roomId: "",
            isRoom: false,
            isExtend: false,
            isCheck: false,
            floorList: []
        }
    },
    created() {
        this.getHotelList("", 1);
    },
    methods: {
        handleCheckInRoom(row) {

            this.roomId = row.id;
            this.isCheck = true;
        },
        handleExtendRoom(row) {
            this.roomId = row.roomOrderId;
            this.isExtend = true;
        },
        handleRefund(row) {
            this.$confirm(`确认给房间号${row.floor}-${row.roomNo}操作退房, 是否继续?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.getRequest(`/api/room/checkOut/${row.id}`)
                .then(res => {
                    let data = res.data;
                    if(data.code == 200) {
                        this.$message.success(data.msg);
                        this.getTableData();
                    }
                })
            });
        },
        handleConfirmRoom() {
            this.isRoom = false;
            this.isCheck = false;
            this.isExtend = false;
            this.getTableData();
        },
        handleEdit(row) {
            this.roomId = row.id;
            this.isRoom = true;
        },
        handleShowDetail(row) {
            this.getRequest(`/api/roomOrder/getDetails?id=${row.roomOrderId}`)
            .then(res => {
                let data = res.data;
                if(data.code == 200) {
                    data.data.idNumber = data.data.roomOrderGuestInfoVoList[0].idNumber;
                    data.data.customerName = data.data.roomOrderGuestInfoVoList[0].name;
                    data.data.customerMobile = data.data.roomOrderGuestInfoVoList[0].mobile;
                    this.modelForm = data.data;
                    this.isDetail = true;
                }
            })
        },
        handleSearch() {
            this.searchForm.pageNumber = 1;
            this.getTableData();
        },

        handleSelectHotel() {
            this.searchForm.pageNumber = 1;
            this.handleReset();
            this.getRoomTypeList();
            this.getFloorList();
        },

        handleReset() {
            this.searchForm = {
                hotelId: this.searchForm.hotelId,
                name: "",
                roomNo: "",
                roomTypeId: "",
                status: "",
            };
            this.getTableData();
        },

        getTableData() {
            this.isLoading = true;
            this.postRequest("/api/room/getAllList", this.searchForm)
                .then(res => {
                    this.isLoading = false;
                    let data = res.data;
                    if (data.code == 200) {
                        this.tableData = data.data;
                    }
                }).catch(() => {
                    this.isLoading = false;
                })
        },
        getRoomTypeList() {
            this.getRequest(`/api/roomType/getByHotelId?hotelId=${this.searchForm.hotelId}`)
            .then(res => {
                let data = res.data;
                if (data.code == 200) {
                    this.roomTypeList = data.data;
                }
            })
        },
        remoteMethod(name) {
            if(name) {
                this.getHotelList(name);
            }
        },
        getHotelList(name,key) {
            this.getRequest("/api/hotel/page", {
                pageSize: 10,
                name: name || ''
            }).then(res => {
                let data = res.data;
                if(data.code == 200) {
                    this.hotelList = data.data.records;
                    if(key && this.hotelList.length) {
                        this.searchForm.hotelId = this.hotelList[0].id;
                        this.getTableData();
                        this.getRoomTypeList();
                        this.getFloorList();
                    }
                }
            })
        },
        getFloorList() {
            this.getRequest(`/floor/getHotelFloor?hotelId=${this.searchForm.hotelId}`)
            .then(res => {
                let data = res.data;
                if(data.code == 200) {
                    this.floorList = data.data;
                }
            })
        },

    },
}
</script>
<style type="less">
@import url("./index.less");
</style>


